<script>
  let date = document.querySelector('meta[name="update"]').content;
</script>



<hr>
<hr>
<hr>
<hr>
<hr>

<footer class="df">
  <ul class="ml-a fz-s">
    <li>
      GitHub: <a href="https://github.com/rplus/pokedex">Rplus / pokedex</a>
    </li>
    <li>
      Data: <a href="https://github.com/pvpoke/pvpoke">PvPoke</a> , <a href="https://github.com/PokeMiners/game_masters">PokeMiners</a>
    </li>
    <li>
      Relesed with: <a href="https://opensource.org/licenses/MIT">MIT license</a>
    </li>
    <li>
      update on:
      <time class="ff-m" datetime={date}>{date.slice(0, 10)}</time>
    </li>
  </ul>
</footer>



<style>
  footer {
    font-style: italic;
    font-family: serif;
    color: #666;
  }

  a {
    color: #66a;
  }

  li {
    list-style-type: square;
  }
</style>
